"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _header = _interopRequireDefault(require("../header"));

var _axios = _interopRequireDefault(require("axios"));

var _DashboardTimezoneDisclaimer = require("./DashboardTimezoneDisclaimer");

var _KeyInsightCard = require("./KeyInsightCard");

var _AnalyticsDateFormatter = _interopRequireDefault(require("./AnalyticsDateFormatter"));

var _utils = require("./utils");

var _LazyCharts = require("./LazyCharts");

var _PopularTopicsTable = _interopRequireDefault(require("./PopularTopicsTable"));

var _PopularCategoriesTable = _interopRequireDefault(require("./PopularCategoriesTable"));

var _Tabs = _interopRequireDefault(require("@insided/deprecated-preact-components/Tabs"));

var _DashboardSimpleFilter = _interopRequireDefault(require("./DashboardSimpleFilter"));

var _DashboardDateRangeFilter = _interopRequireDefault(require("./DashboardDateRangeFilter"));

var _Loader = require("./Loader");

var _DashboardCategoryFilter = _interopRequireDefault(require("./DashboardCategoryFilter"));

var _QueryParameters = _interopRequireDefault(require("./QueryParameters"));

var _GraphTitle = require("./GraphTitle");

var _service = require("@insided/deprecated-control/analytics/service");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ContentDashboard = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ContentDashboard, _Component);

  var _super = _createSuper(ContentDashboard);

  function ContentDashboard(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ContentDashboard);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "wrapperRef", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "barChart", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "horizontalBarChart", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resizeTimeout", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidMount", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var _yield$Promise$all, _yield$Promise$all2, presetDateRanges, roles, contentTypes, defaultDateRange, _dateRangeForDisplay, dateFrom, dateTill, selectedDateRange, selectedPresetId, updatedState, selectedRoles, mainRoles, customRoles;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0, _utils.trackDashboardUsage)('content-dashboard');

              _this.redrawGraphsOnResize();

              _this.setState({
                isContentKeyInsightLoading: true,
                isPostsCreatedAndLikesReceivedGraphLoading: true,
                topicsCreatedPerContentTypeGraphLoading: true,
                topicsCreatedPerUserRoleGraphLoading: true,
                isLoading: true
              });

              _context.prev = 3;
              _context.next = 6;
              return Promise.all([(0, _service.fetchDateRangeFilter)(), (0, _service.fetchUserRoles)().then(function (roleList) {
                return (0, _utils.normalizeRoles)(roleList);
              }), (0, _utils.fetchContentTypes)()]);

            case 6:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = (0, _slicedToArray2.default)(_yield$Promise$all, 3);
              presetDateRanges = _yield$Promise$all2[0];
              roles = _yield$Promise$all2[1];
              contentTypes = _yield$Promise$all2[2];
              defaultDateRange = (0, _utils.getDefaultDateRange)(presetDateRanges, _this.state.selectedPresetDateRangeId);
              _dateRangeForDisplay = (0, _utils.dateRangeForDisplay)(_this.state.storedState, defaultDateRange, _this.state.selectedPresetDateRangeId), dateFrom = _dateRangeForDisplay.dateFrom, dateTill = _dateRangeForDisplay.dateTill, selectedDateRange = _dateRangeForDisplay.selectedDateRange, selectedPresetId = _dateRangeForDisplay.selectedPresetId, updatedState = _dateRangeForDisplay.updatedState;
              selectedRoles = _this.state.selectedRoles;
              mainRoles = (0, _utils.getSelectedRolesForRequest)(roles, selectedRoles);
              customRoles = (0, _utils.getSelectedRolesForRequest)(roles, selectedRoles, false);

              _this.setState({
                isLoading: false,
                userRoles: roles,
                contentTypes: contentTypes,
                presetDateRangeList: presetDateRanges,
                selectedPresetDateRangeId: selectedPresetId,
                selectedDate: selectedDateRange,
                startDate: dateFrom,
                endDate: dateTill,
                storedState: updatedState,
                mainRoles: mainRoles,
                customRoles: customRoles
              });

              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](3);

              _this.setState({
                isLoading: false
              });

            case 22:
              _this.fetchContentKeyInsights();

              _this.fetchTopicsRepliesAndLikesOverTime();

              _this.fetchTopicsPerContentType();

              _this.fetchTopicsPerUserRole();

            case 26:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 19]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "addHandler", function () {
      var _this$state = _this.state,
          isDateRangeOpen = _this$state.isDateRangeOpen,
          isUserRoleDropdownOpen = _this$state.isUserRoleDropdownOpen,
          isContentTypeDropdownOpen = _this$state.isContentTypeDropdownOpen,
          isCategoryDropdownOpen = _this$state.isCategoryDropdownOpen;

      if (isDateRangeOpen || isUserRoleDropdownOpen || isContentTypeDropdownOpen || isCategoryDropdownOpen) {
        window.document.addEventListener('mousedown', _this.handleClickOutside);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "removeHandler", function () {
      window.document.removeEventListener('mousedown', _this.handleClickOutside);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClickOutside", function (e) {
      if (!_this.wrapperRef) return;

      if (!_this.wrapperRef.contains(e.target)) {
        _this.onResetDateRange();

        _this.setState({
          isUserRoleDropdownOpen: false,
          isContentTypeDropdownOpen: false,
          isCategoryDropdownOpen: false
        }, _this.removeHandler);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "redrawGraphsOnResize", function () {
      if (typeof window.ResizeObserver === 'undefined') {
        return;
      }

      var resizeObserver = new ResizeObserver(function () {
        clearTimeout(_this.resizeTimeout);

        _this.setState({
          shouldChartRedraw: true
        });

        _this.resizeTimeout = window.setTimeout(function () {
          return _this.setState({
            shouldChartRedraw: false
          });
        }, 2 * 10);
      });

      if (_this.barChart != null && _this.horizontalBarChart != null) {
        resizeObserver.observe(_this.barChart);
        resizeObserver.observe(_this.horizontalBarChart);
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "refetchData", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.fetchContentKeyInsights();

              _this.fetchTopicsRepliesAndLikesOverTime();

              _this.fetchTopicsPerContentType();

              _this.fetchTopicsPerUserRole();

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchContentKeyInsights", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      var res, _res$data, posts, topics, replies, likes, positiveContentHelpfulness, singleUserTopics, averageResponseTime, postsCreatedPercentageDifference, topicsCreatedPercentageDifference, repliesCreatedPercentageDifference, likesReceivedPercentageDifference, positiveContentHelpfulnessPercentageDifference, singleUserTopicsPercentageDifference;

      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this.setState({
                isContentKeyInsightLoading: true
              });

              _context3.prev = 1;
              _context3.next = 4;
              return _this.fetchData('/analyticsV2/contentKeyInsights');

            case 4:
              res = _context3.sent;
              _res$data = res.data, posts = _res$data.posts, topics = _res$data.topics, replies = _res$data.replies, likes = _res$data.likes, positiveContentHelpfulness = _res$data.positiveContentHelpfulness, singleUserTopics = _res$data.singleUserTopics, averageResponseTime = _res$data.averageResponseTime;
              postsCreatedPercentageDifference = (0, _utils.previousPeriodDifference)(posts.count, posts.previousCount);
              topicsCreatedPercentageDifference = (0, _utils.previousPeriodDifference)(topics.count, topics.previousCount);
              repliesCreatedPercentageDifference = (0, _utils.previousPeriodDifference)(replies.count, replies.previousCount);
              likesReceivedPercentageDifference = (0, _utils.previousPeriodDifference)(likes.count, likes.previousCount);
              positiveContentHelpfulnessPercentageDifference = (0, _utils.previousPeriodDifference)(positiveContentHelpfulness.count, positiveContentHelpfulness.previousCount);
              singleUserTopicsPercentageDifference = (0, _utils.previousPeriodDifference)(singleUserTopics.count, singleUserTopics.previousCount);

              _this.setState({
                postsCreated: {
                  count: posts.count,
                  previousCount: posts.previousCount,
                  percentageDifference: postsCreatedPercentageDifference
                },
                topicsCreated: {
                  count: topics.count,
                  previousCount: topics.previousCount,
                  percentageDifference: topicsCreatedPercentageDifference
                },
                repliesCreated: {
                  count: replies.count,
                  previousCount: replies.previousCount,
                  percentageDifference: repliesCreatedPercentageDifference
                },
                likesReceived: {
                  count: likes.count,
                  previousCount: likes.previousCount,
                  percentageDifference: likesReceivedPercentageDifference
                },
                positiveContentHelpfulness: {
                  count: positiveContentHelpfulness.count,
                  previousCount: positiveContentHelpfulness.previousCount,
                  percentageDifference: positiveContentHelpfulnessPercentageDifference
                },
                singleUserTopics: {
                  count: singleUserTopics.count,
                  previousCount: singleUserTopics.previousCount,
                  percentageDifference: singleUserTopicsPercentageDifference
                },
                averageResponseTime: averageResponseTime,
                isContentKeyInsightLoading: false
              });

              _context3.next = 18;
              break;

            case 15:
              _context3.prev = 15;
              _context3.t0 = _context3["catch"](1);

              _this.setState({
                isContentKeyInsightLoading: false
              });

            case 18:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[1, 15]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchTopicsRepliesAndLikesOverTime", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      var res;
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                isPostsCreatedAndLikesReceivedGraphLoading: true
              });

              _context4.prev = 1;
              _context4.next = 4;
              return _this.fetchData('/analyticsV2/topicsRepliesAndLikesOverTime');

            case 4:
              res = _context4.sent;

              _this.setState({
                postsOverTime: res.data,
                isPostsCreatedAndLikesReceivedGraphLoading: false
              });

              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](1);

              _this.setState({
                isPostsCreatedAndLikesReceivedGraphLoading: false
              });

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchTopicsPerContentType", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      var res;
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this.setState({
                topicsCreatedPerContentTypeGraphLoading: true
              });

              _context5.prev = 1;
              _context5.next = 4;
              return _this.fetchData('/analyticsV2/topicsPerContentType');

            case 4:
              res = _context5.sent;

              _this.setState({
                topicsCreatedPerContentType: res.data,
                topicsCreatedPerContentTypeGraphLoading: false
              });

              _context5.next = 11;
              break;

            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](1);

              _this.setState({
                topicsCreatedPerContentTypeGraphLoading: false
              });

            case 11:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchTopicsPerUserRole", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      var res;
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this.setState({
                topicsCreatedPerUserRoleGraphLoading: true
              });

              _context6.prev = 1;
              _context6.next = 4;
              return _this.fetchData('/analyticsV2/topicsPerUserRole');

            case 4:
              res = _context6.sent;

              _this.setState({
                topicsPerUserRole: res.data,
                topicsCreatedPerUserRoleGraphLoading: false
              });

              _context6.next = 11;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](1);

              _this.setState({
                topicsCreatedPerUserRoleGraphLoading: false
              });

            case 11:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[1, 8]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchData", /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(url) {
        var additionalFilterOptions,
            _this$state2,
            startDate,
            endDate,
            mainRoles,
            customRoles,
            selectedContentTypes,
            selectedCategories,
            filterOptions,
            _args7 = arguments;

        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                additionalFilterOptions = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {};
                _this$state2 = _this.state, startDate = _this$state2.startDate, endDate = _this$state2.endDate, mainRoles = _this$state2.mainRoles, customRoles = _this$state2.customRoles, selectedContentTypes = _this$state2.selectedContentTypes, selectedCategories = _this$state2.selectedCategories;
                filterOptions = {
                  start: _AnalyticsDateFormatter.default.formatDate(startDate),
                  end: _AnalyticsDateFormatter.default.formatDate(endDate, false),
                  mainRoles: mainRoles,
                  customRoles: customRoles,
                  contentTypes: selectedContentTypes,
                  categories: selectedCategories
                };
                _context7.next = 5;
                return _axios.default.post(url, {
                  filters: Object.assign(filterOptions, additionalFilterOptions)
                });

              case 5:
                return _context7.abrupt("return", _context7.sent);

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleUserRoleDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      _this.setState({
        isUserRoleDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onUserRolesChanged", function (data) {
      var userRoles = _this.state.userRoles;
      var mainRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, data);
      var customRoles = (0, _utils.getSelectedRolesForRequest)(userRoles, data, false);

      _this.setState({
        isUserRoleDropdownOpen: false,
        selectedRoles: data,
        mainRoles: mainRoles,
        customRoles: customRoles
      });

      window.history.pushState(null, 'roles changed', new _QueryParameters.default().set('roles', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetUserRoles", function () {
      _this.setState({
        isUserRoleDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearUserRoles", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedRoles: [],
        mainRoles: [],
        customRoles: [],
        isUserRoleDropdownOpen: false
      });

      window.history.pushState(null, 'roles cleared', new _QueryParameters.default().unset('roles').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleContentTypeDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      _this.setState({
        isContentTypeDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onContentTypesChanged", function (data) {
      _this.setState({
        isContentTypeDropdownOpen: false,
        selectedContentTypes: data
      });

      window.history.pushState(null, 'content types changed', new _QueryParameters.default().set('content_types', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetContentTypes", function () {
      _this.setState({
        isContentTypeDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearContentTypes", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedContentTypes: [],
        isContentTypeDropdownOpen: false
      });

      window.history.pushState(null, 'content_types cleared', new _QueryParameters.default().unset('content_types').getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleDateRange", function (value) {
      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      if (_this.state.isCategoryDropdownOpen) {
        _this.onResetCategories();
      }

      _this.setState({
        isDateRangeOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPresetDateRangeChanged", function (selectedDate) {
      _this.setState({
        selectedPresetDateRangeId: selectedDate.id,
        selectedDate: selectedDate
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCustomDateRangeChanged", function (dates) {
      var customSelectedDate = {
        id: 'custom_range',
        label: 'Custom Range',
        startDate: dates[0],
        endDate: dates[1]
      };

      _this.setState({
        selectedDate: customSelectedDate,
        selectedPresetDateRangeId: customSelectedDate.id
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDateRangeChanged", function () {
      var _this$state3 = _this.state,
          selectedDate = _this$state3.selectedDate,
          selectedPresetDateRangeId = _this$state3.selectedPresetDateRangeId;

      _this.setState(function (prevState) {
        return {
          isDateRangeOpen: false,
          startDate: new Date(selectedDate.startDate),
          endDate: new Date(selectedDate.endDate),
          storedState: _objectSpread(_objectSpread({}, prevState.storedState), {}, {
            presetDateRangeId: selectedPresetDateRangeId,
            selectedDateRange: selectedDate
          })
        };
      });

      var queryString = new _QueryParameters.default();
      queryString.set('date_range', selectedPresetDateRangeId);

      if (selectedPresetDateRangeId !== 'custom_range') {
        queryString.unset('date_from').unset('date_till');
      } else {
        queryString.set('date_from', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.startDate)).set('date_till', _AnalyticsDateFormatter.default.formatDateForUrl(selectedDate.endDate));
      }

      window.history.pushState(null, 'date range changed', queryString.getQueryString());
      (0, _utils.updateDateRangeInSessionStorage)(selectedDate);

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetDateRange", function () {
      var _this$state$storedSta = _this.state.storedState,
          presetDateRangeId = _this$state$storedSta.presetDateRangeId,
          selectedDateRange = _this$state$storedSta.selectedDateRange;

      _this.setState({
        isDateRangeOpen: false,
        selectedPresetDateRangeId: presetDateRangeId,
        selectedDate: selectedDateRange
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleCategoryDropdown", function (value) {
      if (_this.state.isDateRangeOpen) {
        _this.onResetDateRange();
      }

      if (_this.state.isContentTypeDropdownOpen) {
        _this.onResetContentTypes();
      }

      if (_this.state.isUserRoleDropdownOpen) {
        _this.onResetUserRoles();
      }

      _this.setState({
        isCategoryDropdownOpen: value
      }, _this.addHandler);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onCategoriesChanged", function (data) {
      _this.setState({
        selectedCategories: data,
        isCategoryDropdownOpen: false
      });

      window.history.pushState(null, 'categories changed', new _QueryParameters.default().set('categories', data.join(',')).getQueryString());

      _this.refetchData();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onResetCategories", function () {
      _this.setState({
        isCategoryDropdownOpen: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onClearCategories", function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this.setState({
        selectedCategories: [],
        isCategoryDropdownOpen: false
      });

      window.history.pushState(null, 'categories cleared', new _QueryParameters.default().unset('categories').getQueryString());

      _this.refetchData();
    });

    var _getStartAndEndDate = (0, _utils.getStartAndEndDate)(),
        initialStartDate = _getStartAndEndDate.initialStartDate,
        initialEndDate = _getStartAndEndDate.initialEndDate,
        initalDateRangeId = _getStartAndEndDate.initalDateRangeId;

    var defaultMetricItem = (0, _utils.createDefaultMetricItem)();
    var queryParams = new _QueryParameters.default();

    _this.setState({
      postsCreated: defaultMetricItem,
      topicsCreated: defaultMetricItem,
      repliesCreated: defaultMetricItem,
      likesReceived: defaultMetricItem,
      positiveContentHelpfulness: defaultMetricItem,
      singleUserTopics: defaultMetricItem,
      averageResponseTime: '',
      topicsCreatedPerContentType: [],
      topicsPerUserRole: [],
      userRoles: [],
      selectedRoles: queryParams.has('roles') ? queryParams.get('roles').split(',') : [],
      mainRoles: [],
      customRoles: [],
      isUserRoleDropdownOpen: false,
      contentTypes: [],
      selectedContentTypes: queryParams.has('content_types') ? queryParams.get('content_types').split(',') : [],
      isContentTypeDropdownOpen: false,
      selectedPresetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
      storedState: {
        presetDateRangeId: queryParams.has('date_range') ? queryParams.get('date_range') : initalDateRangeId,
        selectedDateRange: (0, _utils.getDefaultSelectedDate)()
      },
      startDate: queryParams.has('date_from') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_from')) : initialStartDate,
      endDate: queryParams.has('date_till') ? (0, _utils.getDateWithDefaultTime)(queryParams.get('date_till')) : initialEndDate,
      presetDateRangeList: [],
      isDateRangeOpen: false,
      isLoading: false,
      postsOverTime: [],
      isContentKeyInsightLoading: false,
      isPostsCreatedAndLikesReceivedGraphLoading: false,
      topicsCreatedPerContentTypeGraphLoading: false,
      topicsCreatedPerUserRoleGraphLoading: false,
      selectedCategories: queryParams.has('categories') ? queryParams.get('categories').split(',') : [],
      isCategoryDropdownOpen: false,
      shouldChartRedraw: false
    });

    return _this;
  }

  (0, _createClass2.default)(ContentDashboard, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var categoriesV2 = this.props.categoriesV2;
      var _this$state4 = this.state,
          isContentKeyInsightLoading = _this$state4.isContentKeyInsightLoading,
          isPostsCreatedAndLikesReceivedGraphLoading = _this$state4.isPostsCreatedAndLikesReceivedGraphLoading,
          topicsCreatedPerContentTypeGraphLoading = _this$state4.topicsCreatedPerContentTypeGraphLoading,
          topicsCreatedPerUserRoleGraphLoading = _this$state4.topicsCreatedPerUserRoleGraphLoading,
          postsCreated = _this$state4.postsCreated,
          topicsCreated = _this$state4.topicsCreated,
          repliesCreated = _this$state4.repliesCreated,
          likesReceived = _this$state4.likesReceived,
          positiveContentHelpfulness = _this$state4.positiveContentHelpfulness,
          topicsCreatedPerContentType = _this$state4.topicsCreatedPerContentType,
          topicsPerUserRole = _this$state4.topicsPerUserRole,
          presetDateRangeList = _this$state4.presetDateRangeList,
          userRoles = _this$state4.userRoles,
          selectedRoles = _this$state4.selectedRoles,
          isUserRoleDropdownOpen = _this$state4.isUserRoleDropdownOpen,
          contentTypes = _this$state4.contentTypes,
          selectedContentTypes = _this$state4.selectedContentTypes,
          isContentTypeDropdownOpen = _this$state4.isContentTypeDropdownOpen,
          isDateRangeOpen = _this$state4.isDateRangeOpen,
          selectedPresetDateRangeId = _this$state4.selectedPresetDateRangeId,
          startDate = _this$state4.startDate,
          endDate = _this$state4.endDate,
          isLoading = _this$state4.isLoading,
          selectedDate = _this$state4.selectedDate,
          postsOverTime = _this$state4.postsOverTime,
          selectedCategories = _this$state4.selectedCategories,
          isCategoryDropdownOpen = _this$state4.isCategoryDropdownOpen,
          shouldChartRedraw = _this$state4.shouldChartRedraw,
          singleUserTopics = _this$state4.singleUserTopics,
          averageResponseTime = _this$state4.averageResponseTime;
      return (0, _preact.h)("div", {
        className: "content-dashboard-overview dashboard-overview",
        "data-bounded-context": "Analytics",
        "data-entity": "content-dashboard"
      }, (0, _preact.h)(_header.default, {
        title: "Content Dashboard",
        disableCancelButton: true,
        disableSaveButton: true
      }), (0, _preact.h)("div", {
        className: "filter-container",
        ref: function ref(node) {
          _this2.wrapperRef = node;
        }
      }, (0, _preact.h)(_DashboardDateRangeFilter.default, {
        isLoading: isLoading,
        startDate: startDate,
        endDate: endDate,
        isDropdownOpen: isDateRangeOpen,
        items: presetDateRangeList,
        selectedDate: selectedDate,
        selectedPresetId: selectedPresetDateRangeId,
        toggleDropdown: this.toggleDateRange,
        onChange: this.onDateRangeChanged,
        onReset: this.onResetDateRange,
        onCustomDateChange: this.onCustomDateRangeChanged,
        onPresetDateChange: this.onPresetDateRangeChanged,
        showMonths: 2,
        "data-element-name": "Date range filter",
        "data-track-type": "click"
      }), (0, _preact.h)(_DashboardCategoryFilter.default, {
        isLoading: isLoading,
        id: "categories",
        name: "(parent) category or group",
        customClassName: "categories",
        title: "Published in",
        isDropdownOpen: isCategoryDropdownOpen,
        toggleDropdown: this.toggleCategoryDropdown,
        resetDropdown: this.onResetCategories,
        onClear: this.onClearCategories,
        onChange: this.onCategoriesChanged,
        categoriesV2: categoriesV2,
        selectedItems: selectedCategories
      }), (0, _preact.h)(_DashboardSimpleFilter.default, {
        isLoading: isLoading,
        id: "userRole",
        name: "user role",
        customClassName: "user-role",
        title: "Author user role",
        isDropdownOpen: isUserRoleDropdownOpen,
        toggleDropdown: this.toggleUserRoleDropdown,
        resetDropdown: this.onResetUserRoles,
        onClear: this.onClearUserRoles,
        onChange: this.onUserRolesChanged,
        items: userRoles,
        selectedItems: selectedRoles,
        "data-element-name": "Author user role filter",
        "data-track-type": "click"
      }), (0, _preact.h)(_DashboardSimpleFilter.default, {
        isLoading: isLoading,
        id: "contentType",
        name: "content type",
        customClassName: "content-type",
        title: "Content type",
        isDropdownOpen: isContentTypeDropdownOpen,
        toggleDropdown: this.toggleContentTypeDropdown,
        resetDropdown: this.onResetContentTypes,
        onClear: this.onClearContentTypes,
        onChange: this.onContentTypesChanged,
        items: contentTypes,
        selectedItems: selectedContentTypes,
        "data-element-name": "Content type filter",
        "data-track-type": "click"
      })), (0, _preact.h)("div", {
        className: "metric-container"
      }, (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Posts created",
        total: postsCreated.count,
        titleTooltip: "The number of topics and replies created in the selected time period.",
        percent: postsCreated.percentageDifference,
        isLoading: isContentKeyInsightLoading,
        showComparisionUnavailable: postsCreated.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of topics and replies created in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Topics created",
        total: topicsCreated.count,
        titleTooltip: "The number of topics created in the selected time period.",
        percent: topicsCreated.percentageDifference,
        isLoading: isContentKeyInsightLoading,
        showComparisionUnavailable: topicsCreated.previousCount === 0,
        comparisionTooltip: "The percentage difference between the number of topics created in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Replies created",
        total: repliesCreated.count,
        titleTooltip: "The number of replies created in the selected time period.",
        percent: repliesCreated.percentageDifference,
        showComparisionUnavailable: repliesCreated.previousCount === 0,
        isLoading: isContentKeyInsightLoading,
        comparisionTooltip: "The percentage difference between the number of replies created in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Likes received",
        total: likesReceived.count,
        titleTooltip: "The number of likes received by authors on their topics/replies in the selected time period.",
        percent: likesReceived.percentageDifference,
        showComparisionUnavailable: likesReceived.previousCount === 0,
        isLoading: isContentKeyInsightLoading,
        comparisionTooltip: "The percentage difference between the number of likes received by authors on their topics/replies in the current/previous time period."
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Positive content helpfulness votes",
        total: positiveContentHelpfulness.count,
        titleTooltip: "The number of positive content helpfulness votes given to topics in the selected time period.",
        isLoading: isContentKeyInsightLoading,
        percent: positiveContentHelpfulness.percentageDifference,
        comparisionTooltip: "The percentage difference between the number of positive content helpfulness votes given in the current/previous time period.",
        showComparisionUnavailable: positiveContentHelpfulness.previousCount === 0
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Single user topics",
        total: singleUserTopics.count,
        titleTooltip: "The number of topics in the selected time period where only one user contributed content.",
        isLoading: isContentKeyInsightLoading,
        percent: singleUserTopics.percentageDifference,
        comparisionTooltip: "The percentage difference between the number of topics in the selected time period where only one user contributed content given in the current/previous time period.",
        showComparisionUnavailable: singleUserTopics.previousCount === 0
      }), (0, _preact.h)(_KeyInsightCard.KeyInsightCard, {
        title: "Average response time",
        total: averageResponseTime,
        titleTooltip: "The average amount of time between the creation of a topic and its first reply. Replies from topic starter don't count.",
        isLoading: isContentKeyInsightLoading,
        hideComparisionWithPreviousPeriod: true
      })), (0, _preact.h)("div", {
        className: "graph-wrapper"
      }, (0, _preact.h)("div", {
        className: "graph-container",
        ref: function ref(element) {
          _this2.barChart = element;
        }
      }, (0, _preact.h)("div", {
        className: "graph-row"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        customClass: "with-legend",
        title: "Posts created",
        tooltipMessage: "The topics and replies created in the selected time period."
      }), isPostsCreatedAndLikesReceivedGraphLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: {
          datasets: [{
            label: 'Topics',
            fill: false,
            data: postsOverTime.map(function (d) {
              return {
                x: d.date,
                y: d.topics
              };
            }),
            backgroundColor: _utils.BRAND_BLUE
          }, {
            label: 'Replies',
            fill: false,
            data: postsOverTime.map(function (d) {
              return {
                x: d.date,
                y: d.replies
              };
            }),
            backgroundColor: _utils.BRAND_YELLOW
          }]
        },
        options: (0, _utils.getBarChartOptionsForContentDashboard)(true)
      })), (0, _preact.h)("div", {
        className: "graph-row"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "Likes received",
        tooltipMessage: "The number of likes received by authors on their topics/replies in the selected time period."
      }), isPostsCreatedAndLikesReceivedGraphLoading ? (0, _preact.h)(_Loader.Loader, null) : (0, _preact.h)(_LazyCharts.Bar, {
        redraw: shouldChartRedraw,
        data: {
          datasets: [{
            label: 'Likes received',
            fill: false,
            data: postsOverTime.map(function (d) {
              return {
                x: d.date,
                y: d.likes
              };
            }),
            backgroundColor: _utils.BRAND_BLUE
          }]
        },
        options: (0, _utils.getBarChartOptionsForContentDashboard)(false)
      })))), (0, _preact.h)("div", {
        className: "graph-wrapper-horizontal-bar"
      }, (0, _preact.h)("div", {
        className: "graph-container-horizontal-bar",
        ref: function ref(element) {
          _this2.horizontalBarChart = element;
        }
      }, (0, _preact.h)("div", {
        className: "graph-row-horizontal-bar"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "Topics created per content type",
        customClass: "graph-title-horizontal-bar",
        tooltipMessage: "The % of topics created in the selected time period broken down by the content type of the topic (questions/conversations/articles)."
      }), topicsCreatedPerContentTypeGraphLoading ? (0, _preact.h)(_Loader.Loader, null) : topicsCreatedPerContentType && (0, _preact.h)(_LazyCharts.HorizontalBar, {
        redraw: shouldChartRedraw,
        data: (0, _utils.getTopicsCreatedDataSet)(topicsCreatedPerContentType),
        options: (0, _utils.getTopicsCreatedHorizonalBarOptions)()
      })), (0, _preact.h)("div", {
        className: "graph-row-horizontal-bar"
      }, (0, _preact.h)(_GraphTitle.GraphTitle, {
        title: "Topics created per user role",
        customClass: "graph-title-horizontal-bar",
        tooltipMessage: "The % of topics created in the selected time period broken down by the primary role of the author of the topic."
      }), topicsCreatedPerUserRoleGraphLoading ? (0, _preact.h)(_Loader.Loader, null) : topicsPerUserRole && (0, _preact.h)(_LazyCharts.HorizontalBar, {
        redraw: shouldChartRedraw,
        data: (0, _utils.getTopicsCreatedDataSet)(topicsPerUserRole),
        options: (0, _utils.getTopicsCreatedHorizonalBarOptions)()
      })))), (0, _preact.h)(_Tabs.default, {
        titles: ['Popular topics', 'Popular categories'],
        "data-track-type": "click"
      }, (0, _preact.h)(_PopularTopicsTable.default, {
        endDate: endDate,
        startDate: startDate,
        selectedRoles: selectedRoles,
        selectedContentTypes: selectedContentTypes,
        selectedCategories: selectedCategories,
        fetchData: this.fetchData
      }), (0, _preact.h)(_PopularCategoriesTable.default, {
        endDate: endDate,
        startDate: startDate,
        selectedRoles: selectedRoles,
        selectedContentTypes: selectedContentTypes,
        selectedCategories: selectedCategories,
        fetchData: this.fetchData
      })), (0, _preact.h)(_DashboardTimezoneDisclaimer.DashboardTimezoneDisclaimer, null));
    }
  }]);
  return ContentDashboard;
}(_preact.Component);

var _default = ContentDashboard;
exports.default = _default;